'use client';

import useScrollPosition from '@shared/lib/hooks/use-scroll-position';
import clsx from 'clsx';
import Headroom from 'react-headroom';

export default function NavbarClient({
  fixOnTop,
  topLight,
  children,
  topTransparent = true,
}: {
  fixOnTop?: boolean;
  topLight?: boolean;
  topTransparent?: boolean;
  children: React.ReactNode;
}) {
  const isOnTop = useScrollPosition();

  //
  return (
    <Headroom downTolerance={5} pinStart={-100} style={{ zIndex: '30' }} disable={!!fixOnTop}>
      <nav
        className={clsx(
          'mx-auto flex max-w-[1536px] transform items-center justify-between py-3 duration-500 ease-in-out md:py-4 xl:py-6',
          isOnTop || fixOnTop
            ? topTransparent
              ? 'bg-transparent'
              : topLight
                ? 'border-bd-contrast border-b bg-white'
                : 'bg-bd-dark shadow-bd-dark'
            : 'shadow-bd-secondary border-bd-contrast shadow-xs backdrop-blur-xs border-b bg-white',
          topLight && (isOnTop || fixOnTop) ? 'text-bd-dark' : '',
          !topLight && (isOnTop || fixOnTop) ? 'text-bd-light' : ''
        )}
        style={
          {
            '--navbar-bg':
              isOnTop || fixOnTop
                ? topTransparent
                  ? 'transparent'
                  : topLight
                    ? 'white'
                    : 'var(--color-bd-secondary)'
                : 'white',
            '--navbar-contrast':
              isOnTop || fixOnTop
                ? topTransparent
                  ? 'transparent'
                  : 'var(--color-bd-secondary)'
                : 'var(--color-bd-secondary)',
          } as React.CSSProperties
        }
      >
        {children}
      </nav>
    </Headroom>
  );
}
